/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './update_line_item_quantity';
import '../../../../connect/v2/resources/error';
import '../../../model/order';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "InternalLineItemAttributes": {
                    "fields": {
                      "variantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "quantity": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "InternalAddOnLineItemAttributes": {
                    "fields": {
                      "variantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "LineItemUpdate": {
                    "fields": {
                      "action": {
                        "type": "squareup.solidshop.v2.service.UpdateLineItemQuantityRequest.Action",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lineItemAttributes": {
                        "type": "squareup.solidshop.v2.service.InternalLineItemAttributes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "addOnLineItemAttributes": {
                        "type": "squareup.solidshop.v2.service.InternalAddOnLineItemAttributes",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "LineItemUpdateResponse": {
                    "fields": {
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateInternalLineItemQuantitiesRequest": {
                    "fields": {
                      "orderNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lineItemUpdates": {
                        "type": "squareup.solidshop.v2.service.LineItemUpdate",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateInternalLineItemQuantitiesResponse": {
                    "fields": {
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "order": {
                        "type": "squareup.solidshop.model.Order",
                        "id": 2,
                        "rule": "optional"
                      },
                      "lineItemUpdateResponses": {
                        "type": "squareup.solidshop.v2.service.LineItemUpdateResponse",
                        "id": 3,
                        "keyType": "string"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.InternalLineItemAttributes && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.InternalAddOnLineItemAttributes && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.LineItemUpdate && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.LineItemUpdateResponse && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.UpdateInternalLineItemQuantitiesRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.UpdateInternalLineItemQuantitiesResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE InternalLineItemAttributes @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 12:1
 */
export const InternalLineItemAttributes = $root.lookupType('squareup.solidshop.v2.service.InternalLineItemAttributes');
fixType(InternalLineItemAttributes);
Builder.createAndAttachToType(InternalLineItemAttributes);
/**
 * SOURCE InternalAddOnLineItemAttributes @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 23:1
 */
export const InternalAddOnLineItemAttributes = $root.lookupType('squareup.solidshop.v2.service.InternalAddOnLineItemAttributes');
fixType(InternalAddOnLineItemAttributes);
Builder.createAndAttachToType(InternalAddOnLineItemAttributes);
/**
 * SOURCE LineItemUpdate @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 31:1
 */
export const LineItemUpdate = $root.lookupType('squareup.solidshop.v2.service.LineItemUpdate');
fixType(LineItemUpdate);
Builder.createAndAttachToType(LineItemUpdate);
/**
 * SOURCE LineItemUpdateResponse @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 42:1
 */
export const LineItemUpdateResponse = $root.lookupType('squareup.solidshop.v2.service.LineItemUpdateResponse');
fixType(LineItemUpdateResponse);
Builder.createAndAttachToType(LineItemUpdateResponse);
/**
 * SOURCE UpdateInternalLineItemQuantitiesRequest @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 47:1
 */
export const UpdateInternalLineItemQuantitiesRequest = $root.lookupType('squareup.solidshop.v2.service.UpdateInternalLineItemQuantitiesRequest');
fixType(UpdateInternalLineItemQuantitiesRequest);
Builder.createAndAttachToType(UpdateInternalLineItemQuantitiesRequest);
/**
 * SOURCE UpdateInternalLineItemQuantitiesResponse @ squareup/solidshop/v2/service/orders/update_internal_line_item_quantities.proto at 55:1
 */
export const UpdateInternalLineItemQuantitiesResponse = $root.lookupType('squareup.solidshop.v2.service.UpdateInternalLineItemQuantitiesResponse');
fixType(UpdateInternalLineItemQuantitiesResponse);
Builder.createAndAttachToType(UpdateInternalLineItemQuantitiesResponse);
